import { not, pipe } from 'ramda';
import { useMemo, useState } from 'react';
import { Category } from 'api/timesheets/categories';
import { useTranslation } from 'hooks/use-translation';
import { asList, Categories as CategoriesT, hasData } from '../categories';

export const useCategoriesSettings = (categories: CategoriesT) => {
  const label = useTranslation('settings.timesheets.controls.categories.label');
  const description = useTranslation(
    'settings.timesheets.controls.categories.description',
  );
  const listCaption = useTranslation(
    'settings.timesheets.controls.categories.list.caption',
  );
  const data = useMemo(() => asList(categories), [categories]);
  const loading = useMemo(() => pipe(hasData, not)(categories), [categories]);
  const [editing, setEditing] = useState<Category | null>(null);

  return {
    label,
    description,
    listCaption,
    loading,
    data,
    editing,
    setEditing,
  };
};
